@if (!searchEngineAvailable()) {
	<ul class="list">
		<li class="list-item">
			<div class="label">
				<p translate="search.notavailable"></p>
			</div>
		</li>
	</ul>
} @else {
	@if (filter(workspaces()); as filteredWorkspaces) {
		<ul class="list" stagesClickStopPropagation>
			@for (workspace of filteredWorkspaces; track trackBy($index, workspace)) {
				<li class="list-item" [ngClass]="{ active: preSelected() === workspace.id }">
					<a class="label clickable" (click)="selectWorkspace(workspace)">
						<div class="text">
							<span class="h3" [innerHTML]="workspace.name | highlightMatches: filterTerm"></span>
							<span class="h6">{{ workspace.path }}</span>
						</div>
					</a>
					@if (bookmarkable()) {
						<button
							[attr.title]="
								!workspace.favorite
									? ('navigation.workspace.addworkspacetofavorites' | translate)
									: ('navigation.workspace.removeworkspacefromfavorites' | translate)
							"
							[attr.aria-label]="
								!workspace.favorite
									? ('navigation.workspace.addworkspacetofavorites' | translate)
									: ('navigation.workspace.removeworkspacefromfavorites' | translate)
							"
							(click)="toggleFavorite(workspace)"
							class="action"
						>
							<i class="ico" [ngClass]="{ 'ico-star-border': !workspace.favorite, 'ico-star': workspace.favorite }"></i>
						</button>
					}
				</li>
			}
			@if (filteredWorkspaces.length === 0 && getListIsEmptyProperty() !== undefined) {
				<li class="list-item">
					<div class="label">
						<p [translate]="getListIsEmptyProperty()!"></p>
					</div>
				</li>
			}
		</ul>
	} @else {
		<stages-spin class="spin-without-button" size="sm" />
	}
}
